// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"3029b7c9","290":"6f08bc6c","382":"181af3c1","396":"99c5cf38","544":"2ee4d36c","680":"b3f0bf76","852":"25fddc68"}[chunkId] + ".chunk.js";
};